import { hotlineItem } from "@/app/config/client";
import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import { useMixPanel } from "@/app/context/mixPanelContext";
import Image from "next/image";
import Link from "next/link";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";

const Hotline = ({
  showHotlineModal,
  setShowHotlineModal,
}: {
  showHotlineModal: boolean;
  setShowHotlineModal: Function;
}) => {
  const { trackEvent } = useMixPanel();
  const { config, getImagePath, StringConstantsInstance } =
    useClientConfigProvider();
  const { t } = useTranslation();

  const hotlineDataArr = config?.supports?.hotlineDataArr;

  useEffect(() => {
    if (showHotlineModal) {
      trackEvent(EventLabels.SL_Hotline, { screen: "Support" });
      trackEvent(EventLabels.SL_Hotline_Done, { screen: "Support" });
    }
  }, [showHotlineModal]);

  return (
    <Modal
      zIndex={""}
      isOpen={showHotlineModal}
      toggle={() => {
        setShowHotlineModal(false);
      }}
      centered
      contentClassName="hotline-modal"
    >
      <ModalBody>
        <div className="hotline_modal_container">
          <div className="hotline_modal_header">
            <div className="modal-heading-profile-support">
              {t("hotline.heading")}
            </div>
            <Image
              role="button"
              onClick={() => {
                setShowHotlineModal(false);
              }}
              src={"/common-images/cancel-modal.png"}
              alt={"close"}
              width={"18"}
              height={"18"}
              className="hotline_modal_close"
            />
          </div>
          {hotlineDataArr?.map((item: hotlineItem, index: number) => (
            <HotlineData
              key={index}
              value={item.value}
              label={item.label}
              image={item.image}
              index={index}
              href={item.href}
              cta={item.cta}
              labelTKey={item.labelTKey}
              totalItems={hotlineDataArr.length} // Pass total items for separator logic
            />
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Hotline;

const HotlineData = ({
  value,
  label,
  labelTKey,
  image,
  index,
  href,
  cta,
  totalItems,
}: {
  value: string;
  label: string;
  image: string;
  index: number;
  labelTKey?: string;
  href: string | null;
  cta?: string;
  totalItems: number;
}) => {
  const { trackEvent } = useMixPanel();
  const { config, getImagePath } = useClientConfigProvider();
  const hotlineDataArr = config?.supports?.hotlineDataArr;
  const { t } = useTranslation();
  return (
    <>
      <Link
        href={href ? `${href}${value}` : ""}
        key={index}
        role="button"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          textDecoration: "none",
        }}
        onClick={() => {
          cta && trackEvent(cta, { screen: "Hotline" });
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              backgroundColor: "#b7e9dd1a",

              display: "flex",
              boxShadow: "0px 5px 20px 0px #0000001A",
            }}
          >
            <Image
              style={{ margin: "auto" }}
              src={getImagePath(image)}
              alt={""}
              width={"20"}
              height={"20"}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
            }}
          >
            <div className="hotline-value">{t("hotline." + value, value)}</div>
            <div className="hotline-type">
              {t("hotline." + labelTKey, label)}
            </div>
          </div>
        </div>
        <div
          className={`hotline_redirection_arrow ${
            label === `Working hours` && "d-none"
          }`}
        >
          <Image
            src={"/common-images/right-arrow-black.png"}
            alt={""}
            width={"10"}
            height={"20"}
            className="support-go-to-arrow"
          />
        </div>
      </Link>

      {(hotlineDataArr?.length ?? 0) - 1 > index && (
        <hr className="hotline-horizontal-line" />
      )}
    </>
  );
};
